import { auth } from "../firebase";
import { getFunctionsURL } from "./getFunctionsURL";

export const authPost = (url, payload) => {
	return wrappedFetch(url, payload, {
		"content-type": "application/json"
	});
};

export const authGet = url => {
	return wrappedFetch(url, {});
};

const wrappedFetch = (
	endpoint: string,
	request: RequestInit,
	extraHeaders?: { [header: string]: string }
): Promise<Response> => {
	let API_URL = getFunctionsURL();
	if (!auth.currentUser) {
		return fetch(API_URL + endpoint);
	}
	return auth.currentUser.getIdToken().then(token => {
		return fetch(API_URL + endpoint, {
			...request,
			headers: {
				Authorization: "Bearer " + token,
				...extraHeaders
			}
		});
	});
};

(window as any).wrappedFetch = wrappedFetch;
console.log("at this point");



// WEBPACK FOOTER //
// ./src/utils/authenticatedRequest.ts